/**
 * Auth Cache Utilities
 * מנהל ניקוי של localStorage כשיש בעיית session
 */

const AUTH_CACHE_KEYS = [
  'businessId',
  'lf_business_cache',
  'lf_boot_grace_until',
  'supabase.auth.token',
  'sb-auth-token',
];

/**
 * מנקה את כל המידע הקשור ל-authentication מ-localStorage
 */
export function clearAuthCache(): void {
  console.log('[AuthCache] Clearing all auth cache...');

  AUTH_CACHE_KEYS.forEach(key => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.warn(`[AuthCache] Failed to remove ${key}:`, error);
    }
  });

  // נקה גם את כל המפתחות שמתחילים ב-sb- (Supabase)
  try {
    const keys = Object.keys(localStorage);
    keys.forEach(key => {
      if (key.startsWith('sb-')) {
        localStorage.removeItem(key);
      }
    });
  } catch (error) {
    console.warn('[AuthCache] Failed to clear Supabase keys:', error);
  }

  console.log('[AuthCache] Cache cleared successfully');
}

/**
 * בודק אם יש מידע ישן ב-localStorage שעלול לגרום לבעיות
 */
export function hasStaleCache(): boolean {
  const businessId = localStorage.getItem('businessId');
  const businessCache = localStorage.getItem('lf_business_cache');

  return !!(businessId || businessCache);
}

/**
 * רושם debug info על מצב ה-cache
 */
export function logCacheState(): void {
  console.log('[AuthCache] Current state:', {
    businessId: localStorage.getItem('businessId'),
    hasBusinessCache: !!localStorage.getItem('lf_business_cache'),
    hasBootGrace: !!localStorage.getItem('lf_boot_grace_until'),
    supabaseKeys: Object.keys(localStorage).filter(k => k.startsWith('sb-')),
  });
}
